
        import '/home/builduser/.yarn/berry/cache/@wix-editor-elements-panel-npm-1.149.0-48f4faae12-10.zip/node_modules/@wix/editor-elements-panel/dist/esm/sections/Components/ShadowInput/ShadowInput.scss.css.virtualfile';
        module.exports = {"label":"_label_1der7_1"};